import { SectionHeading } from "./SectionHeading";
import { stack } from "../../data/portfolioData";

export const StackSection = () => {
    return (
        <section
            id="stack"
            data-testid="stack-section"
            className="relative scroll-mt-24 px-6 py-24 md:px-12 md:py-32 lg:px-16"
        >
            <div className="mx-auto max-w-7xl">
                <SectionHeading
                    index="04"
                    kicker="Technical stack"
                    title="The tools I reach for, grouped by where they live."
                    subtitle="Not a keyword dump — just what I actually use, organised by part of the system."
                />

                <div className="grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-8">
                    {stack.map((g, idx) => (
                        <div
                            key={g.group}
                            data-testid={`stack-group-${g.group.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                            className="rounded-xl border border-[var(--ink-border)] bg-[var(--ink-surface)] p-6 md:p-8"
                        >
                            <div className="mb-5 flex items-center gap-3">
                                <span className="font-mono text-xs text-ink-cyan">
                                    {String(idx + 1).padStart(2, "0")}
                                </span>
                                <h3 className="text-base font-medium text-[var(--ink-text-primary)] md:text-lg">
                                    {g.group}
                                </h3>
                                <span className="ml-auto h-px flex-1 bg-[var(--ink-border)]" />
                            </div>

                            <div className="flex flex-wrap gap-2">
                                {g.items.map((it) => (
                                    <span
                                        key={it}
                                        className="rounded-full border border-[var(--ink-border)] bg-[var(--ink-bg)] px-3 py-1.5 font-mono text-xs text-[var(--ink-text-primary)] transition-colors hover:border-ink-cyan/40 hover:text-ink-cyan"
                                    >
                                        {it}
                                    </span>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default StackSection;
